// extracted by mini-css-extract-plugin
export default {"profileItem":"profileItems_profileItem__niYY8"};